import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
// import UserImage from '../../assets/icons/User_Image.svg';
import MemberId from '../../assets/icons/vectors/MemberID.svg';
import MemberName from '../../assets/icons/vectors/MemberName.svg';
import Mobile from '../../assets/icons/vectors/Mobile.svg';
import Email from '../../assets/icons/vectors/EmailID.svg';
import City from '../../assets/icons/vectors/City.svg';
import Address from '../../assets/icons/vectors/Address.svg';
import { useDispatch, useSelector } from 'react-redux';
import { SERVICES } from '../Services';
import fetchData from '../FetchData';
import { get } from '../ApiHandler/apihandler';
import Loader from '../Loader/Loader';
const MainContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: #e3f0ff;
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  align-content: flex-start;
  @media (max-width: 1024px) {
    width: 100%;
    flex-direction: column;
  }
`;
const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  width: 50%;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 12%;
  margin-right: 30px;
  @media (max-width: 767px) {
    margin-right: 0px;
  }
`;
const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  @media (max-width: 768px) {
    align-items: flex-start;
    padding-left: 0px;
  }
`;

const RightInnerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
`;

const Ellipse = styled.div`
  position: relative;
  width: 125px;
  height: 125px;
  background: white;
  border-radius: 50%;
  overflow: hidden;
  margin: 0px;
  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin: 0;
  }
`;

const UserImageContainer = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const Icon = styled.img`
  width: 20px;
  height: 20px;
`;
const TextContainer = styled.div`
  width: 76%; /* Adjust this width based on your design and needs */
`;

const Text = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || '400'};
  font-size: 16px;
  line-height: 25px;
  color: #006a61;
  white-space: normal;
  word-wrap: break-word;
  margin: 5px;
`;
// const ConditionalText = styled.p`
//   font-family: 'Noto Sans';
//   font-style: normal;
//   font-weight: ${(props) => props.fontWeight || '400'};
//   font-size: 18px;
//   line-height: 25px;
//   color: #1b544f;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   @media (max-width: 767px) {
//     display: none;
//   }
// `;
const Label = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-size: 14px;
  font-weight: ${(props) => props.fontWeight || '600'};
  line-height: 25px;
  color: #505050;
  width: 130px;
  margin-right: 10px;
  margin: 0px;
  @media (max-width: 767px) {
    display: none;
  }
`;

const Initials = styled.div`
  font-size: 60px;
  @media (max-width: 767px) {
    font-size: 40px;
  }
`;

const UserInfo = () => {
  const memberId = useSelector((state) => state.member.memberId);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({});
  const [profileData, setProfileData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getInitials = (name) => {
    if (typeof name !== 'string') {
      return '';
    }

    const initials = name
      .split(' ')
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase();

    return initials;
  };

  const fetchUserData = useCallback(async () => {
    const url = SERVICES.MEMBER_DETAILS(memberId);
    await fetchData(url, setUserData, dispatch, setIsLoading);
  }, [memberId, dispatch]);
  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
      // if (response.status === 403) {
      //   dispatch(logoutAction());
      // } else {
      //   console.error('Failed to fetch Division Type data');
      // }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  useEffect(() => {
    getUserRole();
  }, []);
  return (
    <>
      <CenteredContainer>
        <MainContainer>
          <LeftContainer>
            <Ellipse>
              <UserImageContainer>
                {profileData.profilePhotoUrl !== null ? (
                  <Image src={profileData?.profilePhotoUrl} alt="User Image" />
                ) : (
                  <Initials>{getInitials(profileData?.fullName)}</Initials>
                )}
                {/* <Image src={profileData?.profilePhotoUrl} alt="User Image" /> */}
              </UserImageContainer>
            </Ellipse>
          </LeftContainer>
          <RightContainer>
            <RightInnerContainer>
              <Icon src={MemberId} alt="/icon" />
              <Label>Member ID</Label>
              <TextContainer>
                <Text fontWeight="600">{userData.id}</Text>
              </TextContainer>
              {/* <Text fontWeight="600">{userData.id}</Text> */}
            </RightInnerContainer>
            <RightInnerContainer>
              <Icon src={MemberName} alt="/icon" />
              <Label>Member Name</Label>
              <TextContainer>
                <Text fontWeight="600">{userData.fullName}</Text>
              </TextContainer>
              {/* <Text fontWeight="600">{userData.fullName}</Text> */}
            </RightInnerContainer>
            <RightInnerContainer>
              <Icon src={Mobile} alt="/icon" />
              <Label>Mobile</Label>
              <TextContainer>
                <Text fontWeight="600">{userData.mobileNumber}</Text>
              </TextContainer>
            </RightInnerContainer>
            <RightInnerContainer>
              <Icon src={Email} alt="/icon" />
              <Label>Email ID</Label>
              <TextContainer>
                <Tooltip title={userData.emailId} placement="top-start">
                  <Text fontWeight="600">{userData.emailId}</Text>
                </Tooltip>
                {/* <Text fontWeight="600">{userData.emailId}</Text> */}
              </TextContainer>
              {/* <Text fontWeight="600">{userData.emailId}</Text> */}
            </RightInnerContainer>
            <RightInnerContainer>
              <Icon src={Address} alt="/icon" />
              <Label>Address</Label>
              <TextContainer>
                {/* <Text>Address</Text> */}
                <Tooltip title={userData.addressLine1} placement="top-start">
                  <Text fontWeight="600">{userData.addressLine1}</Text>
                </Tooltip>
                {/* <Text fontWeight="600">{userData.addressLine1}</Text> */}
              </TextContainer>
            </RightInnerContainer>
            <RightInnerContainer>
              <Icon src={City} alt="/icon" />
              <Label>City</Label>
              <TextContainer>
                <Text fontWeight="600">{userData.cityName}</Text>
              </TextContainer>
              {/* <Text fontWeight="600">{userData.cityName}</Text> */}
            </RightInnerContainer>
          </RightContainer>
        </MainContainer>
      </CenteredContainer>
      {isLoading && <Loader />}
    </>
  );
};

export default UserInfo;
